export function safeRedirect(value: string | null, fallback = "/flows") {
  if (!value) return fallback;
  try {
    if (/^(https?:)?\/\//i.test(value)) return fallback;
    if (!value.startsWith("/")) return fallback;
    if (value.startsWith("/auth")) return fallback;
    const url = new URL(value, window.location.origin);
    return url.pathname + url.search + url.hash;
  } catch {
    return fallback;
  }
}

